import { Icon, Button } from "@legal-500/legal500-design-system";
import styles from "./Modal.module.css";

type UnsavedChangesModalProps = {
  onClose: () => void;
  onConfirm: () => void;
};

export function UnsavedChangesModal({ onClose, onConfirm }: UnsavedChangesModalProps) {
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={`${styles.modalContainer} ${styles["modal-small"]}`}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Unsaved Changes</h2>
          <button className={styles.modalCloseButton} onClick={onClose} aria-label="Close">
            <Icon icon="cross" size="small" />
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.unsavedChanges}>
            <div className={styles.unsavedMessage}>
              <Icon icon="exclamation" size="small" />
              <p>
                You have unsaved changes that will be lost if you continue. Are you sure you want to
                discard these changes?
              </p>
            </div>
          </div>
        </div>
        <div className={styles.modalBody}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <Button onClick={onClose} variant="outlined" color="default">
              Cancel
            </Button>
            <Button onClick={onConfirm} variant="contained" color="primary">
              Discard Changes
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
